export const environment = {
  envName: 'tst',
  production: false,
  engine_endpoint_url: 'https://tst.api.theparagons.nl'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts